import { AutogenModelCity, AutogenRowCity } from "./autogen/AutogenModelCity";

export class ModelCity extends AutogenModelCity<RowCity> {
	constructor() {
		super(RowCity);
	}
}

export class RowCity extends AutogenRowCity {
}